import axios from 'axios'
import wx from 'weixin-js-sdk'
import store from '@/store/index'
import {
    getWxConfig
} from '@/api/user'
import toast from '@/utils/toast';

// 微信所需权限
const jsApiList = ['chooseImage', 'previewImage']
// 文件上传地址
const uploadUrl = 'https://www.zzbjr.cn/akfile/do/upload?project=cos&code=head'
// 文件地址前缀
const ossUrl = 'https://www.zzbjr.cn/akfile/view/'
// 创建axios实例
const service = axios.create({
    // 上传文件不校验凭证
    withCredentials: false,
    timeout: 10000 // 请求超时时间
})

// 上传文件
// localData base64
export function upFile(localData) {
    return new Promise((resolve, reject) => {
        // 将base64转换为file对象
        const file = dataURLtoFile(
            localData,
            'wx/wxup.jpg'
        )
        // 构造FormData对象
        const formData = new FormData()
        // 通过append向form对象添加数据
        formData.append('file', file)
        // FormData私有类对象,访问不到,可以通过get判断值是否传进去
        // //console.log(formData.get('file'))
        // 添加请求头
        const config = {}
        toast.loading('正在上传中...');
        // 通过ajax上传文件
        service.post(uploadUrl, formData, config)
            .then(res => {
                toast.clear();
                if (res.data && res.data.length) {
                    resolve(`${ossUrl}${res.data[0]}`)
                }
            }).catch(() => {
                toast.clear();
            })
    })
}

// base64转换为file对象
export function dataURLtoFile(dataurl, filename) {
    const arr = dataurl.split(',')
    const mime = arr[0].match(/:(.*?);/)[1]
    const bstr = atob(arr[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n)
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], filename, {
        type: mime
    })
}

// 选择并上传图片
export function chooseAndUpImage(data) {
    return new Promise((resolve, reject) => {
        // 初始化微信环境
        getWxJsConfig(data).then(() => {
            // 选择图片
            wx.chooseImage({
                count: 1, // 默认9
                success: res => {
                    // 获取本地图片
                    wx.getLocalImgData({
                        localId: res.localIds[0], // 图片的localID
                        success: resData => {
                            // console.log(res)
                            let localData = resData.localData;
                            // 安卓机型不会返回data:image/jpeg;base64,所以在这里我们需要手动加上去
                            if (localData.indexOf('data:image') !== 0) {
                                // 判断是否有这样的头部
                                localData = 'data:image/jpeg;base64,' + localData
                            }
                            // 第一个替换的是换行符,第二个替换的是图片类型,因为在IOS机上测试时看到它的图片类型时jgp,
                            // 这不知道时什么格式的图片,为了兼容其他设备就把它转为jpeg
                            localData = localData.replace(/\r|\n/g, '').replace('data:image/jgp', 'data:image/jpeg')
                            // localData是图片的base64数据,可以用img标签显示
                            // 上传图片
                            resolve(upFile(localData))
                        }
                    })
                }
            })
        })
    })
}

// 提取出来的公共方法
/*
 * 判断是否IOS环境
 * */
export function isIOS() {
    const isIphone = navigator.userAgent.includes('iPhone'),
        isIpad = navigator.userAgent.includes('iPad');
    return isIphone || isIpad;
}

// 初始化微信环境
export function getWxJsConfig(data) {
    return new Promise((resolve, reject) => {
        // 判断当前是否微信环境
        if (store.state.isWeiXin) {
            if (data.isReady) {
                // console.log('微信环境已准备')
                resolve()
            } else {
                let href = location.href;
                // ios需要特别处理地址，否则在多个需要上传图片的环境会授权失败
                if (isIOS) {
                    href = href.split('#')[0]
                }
                // console.log('请求微信配置')
                // 请求获取微信配置
                getWxConfig({
                    url: href
                }).then(res => {
                    const wxConfig = res.data
                    wxConfig.jsApiList = data.jsApiList || jsApiList
                    // 初始化微信配置
                    wx.config(wxConfig)
                    // 初始化微信环境
                    wx.ready(() => {
                        // 检查微信jsapi是否可用
                        wx.checkJsApi({
                            jsApiList: wxConfig.jsApiList,
                            success: resData => {
                                if (
                                    resData.checkResult.getLocation === false
                                ) {
                                    toast.fail('你的微信版本太低,不支持微信JS接口,请升级到最新的微信版本！');
                                } else {
                                    data.isReady = true;
                                    resolve()
                                }
                            }
                        })
                    })
                    wx.error((res) => {
                        toast.fail('验证失败，请重试！');
                        // 延迟标识失败
                        setTimeout(() => {
                            data.isReady = false;
                        }, 500)
                    });
                })
            }
        }
    })
}